/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LeftBuccalNoRetractors/view.blocks to change it.
import React from 'react'
import sourceJpg from "./source.jpg"
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function LeftBuccalNoRetractors({
  children,
  viewPath = "/DesignSystem/Images/LeftBuccalNoRetractors",
  alignSelf = "auto",
  backgroundColor = "transparent",
  borderBottomLeftRadius = 0,
  borderBottomRightRadius = 0,
  borderTopLeftRadius = 0,
  borderTopRightRadius = 0,
  height = 267,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  source = sourceJpg,
  width = 519
  
}) {
  return (<React.Fragment
>
<img
  data-testid="LeftBuccalNoRetractors.Image"
  data-view-path={viewPath}
 alt={""}
 src={source}
 style={{'--as-1-jvHxn': alignSelf,'--bc-2-jvHxn': backgroundColor,'--bblr-3-jvHxn': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-4-jvHxn': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--btlr-5-jvHxn': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-6-jvHxn': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--h-7-jvHxn': typeof height === 'number' ? `${height}px` : height,'--mb-8-jvHxn': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-9-jvHxn': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-10-jvHxn': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-11-jvHxn': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--w-12-jvHxn': typeof width === 'number' ? `${width}px` : width}}
 className={`views-block ${styles.Image}`}
/>
{children}
</React.Fragment>)
}